module.exports = __webpack_public_path__ + "static/media/Kick.19c99051.wav";